export default "<p>cronograma aquí</p>\r\n"